var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.34,501.66c13.79,13.79,36.2,13.79,49.98,0L256,305.98l195.68,195.68c13.79,13.79,36.2,13.79,49.98,0 c13.79-13.79,13.79-36.2,0-49.98L305.98,256L501.66,60.32c13.79-13.79,13.79-36.2,0-49.98c-13.79-13.79-36.2-13.79-49.98,0 L256,206.02L60.32,10.34c-13.79-13.79-36.2-13.79-49.98,0c-13.79,13.79-13.79,36.2,0,49.98L206.02,256L10.34,451.68 C-3.45,465.47-3.45,487.88,10.34,501.66z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose20);
export default __webpack_public_path__ + "static/media/close_20.d43a16b54b47991cc9c5157bb1bd42e3.svg";
export { ForwardRef as ReactComponent };